import { Cancel, CheckCircle, Error, HourglassEmpty, Settings, SvgIconComponent } from '@mui/icons-material';
import type { ChipProps } from '@mui/material';

type OrderStatusConfig = {
  chipColor: Extract<ChipProps['color'], 'error' | 'success' | 'warning'>;
  iconColor: 'error.main' | 'success.main' | 'warning.main';
  Icon: SvgIconComponent;
};

const ORDER_STATUS_CONFIG: Readonly<Record<string, OrderStatusConfig>> = {
  cancelled: { chipColor: 'error', iconColor: 'error.main', Icon: Cancel },
  completed: { chipColor: 'success', iconColor: 'success.main', Icon: CheckCircle },
  payment_failed: { chipColor: 'error', iconColor: 'error.main', Icon: Error },
  pending: { chipColor: 'warning', iconColor: 'warning.main', Icon: HourglassEmpty },
  processing: { chipColor: 'warning', iconColor: 'warning.main', Icon: Settings },
};

export function getOrderStatusConfig(orderStatus: string): OrderStatusConfig | undefined {
  return ORDER_STATUS_CONFIG[orderStatus];
}
